module.exports = require("anteros-react-core");


//////////////////
// WEBPACK FOOTER
// external "anteros-react-core"
// module id = 2
// module chunks = 0